











import { defineComponent } from '@nuxtjs/composition-api';

import SkeletonShimmer from '~/components/SkeletonShimmer.vue';

export default defineComponent({
  name: 'StoreCardSkeleton',
  components: { SkeletonShimmer },
});
